<template>
  <div class="industry-chip" :style="{ backgroundColor: getIndustryColor }">
    {{ industry.name }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'IndustryChip',
  props: {
    industry: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['industries']),
    getIndustryColor() {
      const industry = this.industries.find((industry) => industry._id === this.industry._id)
      return industry?.color || '#00448c'
    },
  },
}
</script>

<style lang="scss" scoped>
.industry-chip {
  padding: 4px 16px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: bold;
  background-color: $cinza-l90;
  color: white;
  white-space: nowrap;
  width: fit-content;
  user-select: none;
}
</style>
